<template><div><h1 id="merkmale-ereignis" tabindex="-1"><a class="header-anchor" href="#merkmale-ereignis"><span>Merkmale (Ereignis)</span></a></h1>
<p>Merkmale zu Ereignissen — Anzeige der Merkmale zu den Ereignissen/Ereignispositionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Ereignisse und Ereignispositionen können mit Merkmalen (im Zusammenhang mit Ereignissen auch &quot;Attribute&quot; genannt) ergänzt werden. Die Merkmale enthalten zusätzliche Informationen zu den Ereignissen oder dienen als Selektionshilfe für Auswertungen.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Ereignismerkmale</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Gruppe</dt>
<dd>Ereignismerkmalgruppe</dd>
<dt>Merkmal</dt>
<dd>Ereignismerkmal</dd>
<dt>Beschreibung</dt>
<dd>Kurze Beschreibung des Ereignismerkmals</dd>
<dt>Wert</dt>
<dd>Wert-Eintrag gemäss Parametrisierung des Merkmals (z.B. Auswahlliste).</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
</div></template>


